export const PRIVACY_POLICY_URL = 'https://www.wastepay.com/privacy-policy'
export const ACCESSIBILITY_STATEMENT_URL = 'https://www.wastepay.com/accessibility-statement'
export const CONTACT_US_URL = 'https://www.wastepay.com/contact-us'
export const MARKETING_HOME_PAGE_URL = 'https://www.wastepay.com'

export const STANDARD_PAY_PRIVACY_POLICY_URL = 'https://www.standardpay.com/privacy-policy'
export const STANDARD_PAY_ACCESSIBILITY_STATEMENT_URL = 'https://www.standardpay.com/accessibility-statement'
export const STANDARD_PAY_CONTACT_US_URL = 'https://www.standardpay.com/contact-us'
export const STANDARD_PAY_MARKETING_HOME_PAGE = 'https://www.standardpay.com'
